import { useMemo } from 'react';
import { TabContext } from './TabContext';
import type { TabsProviderProps } from './Tabs.types';

export function TabsProvider({
  activeTabId = null,
  activeTabIndex,
  prevActiveTabId = null,
  prevActiveTabIndex,
  tabs,
  setActiveTab,
  registerTab,
  unregisterTab,
  tabContentAnimation,
  children,
}: TabsProviderProps) {
  const ctxValue = useMemo(() => ({
    activeTabId,
    activeTabIndex,
    prevActiveTabId,
    prevActiveTabIndex,
    tabs,
    setActiveTab,
    registerTab,
    unregisterTab,
    tabContentAnimation,
  }), [
    activeTabId,
    activeTabIndex,
    prevActiveTabId,
    prevActiveTabIndex,
    tabs,
    setActiveTab,
    registerTab,
    unregisterTab,
    tabContentAnimation,
  ]);

  return (
    <TabContext.Provider value={ctxValue}>
      {children}
    </TabContext.Provider>
  );
}
